
$(document).ready(function(){
    /**
     *  Expend search form when hover on search icon
     */
    var searchForm = $('.navbar-form ');
    var inputGroup = $('.input-group', searchForm);
    inputGroup.mouseenter(function(){
        $(this).addClass('expand');
    });
    inputGroup.mouseleave(function(){
        $(this).removeClass('expand');
    });
});

